export const TEXT_AREA_MAX_LENGTH = 200;
export const DEMO_SKJEMAVARIANT_URL_PARAM_KEY = "demoSkjemavariant";
